// src/utils/httpClient.js
import { checkExpToken, getToken, saveTokenInStorage } from './helper';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { logoutUser, refreshTokenFunc } from '@app/store/reducers/auth';
import store from '@app/store/store';
import { REFRESH_TOKEN_KEY } from '@app/utils/define';
import { userManager } from '@app/utils/oidc';
import { BaseGateway } from '@app/utils/apiUrl';
import jwt_decode from 'jwt-decode';

// để ngoài để tránh người dùng click nhiều lần gây ra nhiều lần gọi refresh token
// nếu có nhiều lần gọi thì sẽ chỉ có 1 lần gọi thực sự, các lần gọi sau sẽ đợi promise về null

let renewing = false;

async function ensureToken() {
  let user = await userManager.getUser();

  // not logged in?
  if (!user) {
    store.dispatch(logoutUser());
    window.location.href = URI_INTERNAL.LOGIN_PATH;
    throw new Error('Not authenticated');
  }

  // expired or about to expire?
  // if (user.expired) {
  //   if (!renewing) {
  //     renewing = true;
  //     try {
  //       user = await userManager.signinSilent();
  //     } catch (e) {
  //       store.dispatch(logoutUser());
  //       window.location.href = URI_INTERNAL.LOGIN_PATH;
  //       throw e;
  //     } finally {
  //       renewing = false;
  //     }
  //   } else {
  //     // another call is already renewing
  //     while (renewing) {
  //       await new Promise((r) => setTimeout(r, 50));
  //     }
  //     user = await userManager.getUser();
  //   }
  // }

  return user.access_token;
}

export async function fetchWithAuth(input, init = {}) {
  init.headers = new Headers(init.headers || {});
  init.credentials = 'include';

  // 1) make sure token is valid (and renewed if needed)
  const token = await ensureToken();
  init.headers.set('Authorization', `Bearer ${token}`);

  // 2) do the fetch
  return fetch(input, init);
}

// export async function fetchWithToken(input, token, init = {}) {
//   init.headers = new Headers(init.headers || {});
//   init.credentials = 'include';

//   if (token) {
//     init.headers.set('Authorization', `Bearer ${token}`);
//   }

//   return fetch(input, init);
// }

export async function getRoleUser() {
  const user = await userManager.getUser();
  const id_token = user?.id_token || '';
  var decodedToken = jwt_decode(id_token);
  let currentDate = new Date();
  if (decodedToken.exp * 1000 < currentDate.getTime()) {
    userManager.removeUser();
    window.location.href = `${BaseGateway}/connect/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + "/")}`;
  }
  return decodedToken.role = decodedToken.role || [];
}